import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';

export interface IInputSelectOptions {
  label: string;
  value: string;
}

export interface IInputSelectOptionsNew {
  text: string;
  value: string;
}

export type OptionsType<T extends IInputSelectOptionsNew> = {
  [P in keyof T]: T[P]
}

// USAR InputDropdownComponent
@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss']
})
export class InputSelectComponentLEGADO {

  @Input() placeHolder: string = ''
  @Input() control: FormControl = new FormControl('');
  @Input() options: OptionsType<IInputSelectOptionsNew>[] = [];
  @Input() disabled: boolean = false;
  @Input() value: string | null = null;
  @Input() size: 'sml' | 'md' | 'big' = 'md';

  @Output() onSelect = new EventEmitter<string>();

  ngOnInit(): void {
    this.control.patchValue(this.value ?? '')
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.control.patchValue(this.value ?? '');
    }
    if (changes['disabled']) {
      if (this.disabled) {
        this.control.disable();
      } else {
        this.control.enable();
      }
    }
  }

  onChange(value: Event) {
    const target = value.target as HTMLSelectElement;
    const selectedOption = target.options[target.selectedIndex];
    this.onSelect.emit(selectedOption.value);
  }
}
